import React,{useState,useEffect, useCallback} from "react";
import "../../assets/styles/style.css";
import logo from "../../assets/logos/log.jpg";
import refreshIcon from "../../assets/icons/refresh-icon.svg"
import searchIcon from "../../assets/icons/search-icon.svg"
import helpIcon from "../../assets/icons/help-icon.svg"
import useMediaQuery from '@mui/material/useMediaQuery';
const Header = ({placeholder,isHomePage,onSearch}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [role, setRole]=useState();
  const [searchTerm, setSearchTerm] = useState('');

  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false);
  };
  const handleRefresh = () => {
    window.location.reload();
  };
  const getUserData =()=>{
    setRole(localStorage.getItem('Role'));
  }
  const handleSearch = useCallback (() => {
     onSearch(searchTerm);
   },[searchTerm,onSearch]);
  useEffect(() => {
    getUserData();
  }, []);
  useEffect(() => {
    // Si `onSearch` est défini, appeler la fonction handleSearch
    if (onSearch) {
      handleSearch();
    }
  }, [searchTerm, onSearch,handleSearch]);

  return (
    <div className="header">
      <div className="logo">
        <img src={logo} alt="" width={130} height='50px'  />
      </div>
      {
        !isHomePage &&   <div className={`search-bar ${isFocused ? 'focused' : ''}`}>
        <input type="text" placeholder={placeholder}
        onFocus={handleInputFocus}  
        onBlur={handleInputBlur}
        onChange={(e) => (setSearchTerm(e.target.value))}
        style={{ fontSize: isSmallScreen ? '11px' : '16px' ,width:'100%'}}
        />
        <img src={searchIcon} alt="" onClick={handleSearch} />
      </div>
      }

      <div className="icon">
        <div className="icons">
          <img src={refreshIcon} alt="" width={isSmallScreen ? 20 : 28} onClick={handleRefresh}/>
        </div>
        <div className="icons" >
        <img src={helpIcon} alt="" width={isSmallScreen ? 20 : 28} />
        </div>
      </div>

      <div className="txtLoger">
        {
          role && (
            <h3 style={{ fontSize: isSmallScreen ? '16px' : '22px' }}>{ role.charAt(0).toUpperCase() + role.slice(1)}</h3>
          )
        }
      
      </div>
    </div>
  );
};

export default Header;
